import { useMemo } from 'react'
import Mask from '@helpers/Mask'
import moment from 'moment'
import IOrder from '@interfaces/IOrder'
import IUser from '@interfaces/IUser'

export const useOrderData = (user: IUser | null, inProgressOrder: IOrder | null) => {
  const userPhone = useMemo(() => {
    if (!user) return ''
    return Mask.cellphoneView(user.whatsapp || user.cellphone || user.telephone || '')
  }, [user])

  const clinicAddress = useMemo(() => {
    if (!inProgressOrder?.clinic?.main_address) return null

    const mainAddress = inProgressOrder.clinic.main_address
    const { street, number, neighborhood, city, state } = mainAddress
    const zipCode = mainAddress.zip_code ? Mask.zipCode(mainAddress.zip_code) : ''

    return {
      firstAddress: `${street}, ${number} - ${neighborhood}`,
      secondAddress: `${city} - ${state}, ${zipCode}`,
      city,
      state,
    }
  }, [inProgressOrder?.clinic])

  const clinicPhone = useMemo(() => {
    if (!inProgressOrder?.clinic) return ''
    const phone = inProgressOrder.clinic.telephone || inProgressOrder.clinic.cellphone || ''
    return Mask.cellphoneView(phone.toString())
  }, [inProgressOrder?.clinic])

  const formattedTreatmentDate = useMemo(() => {
    if (!inProgressOrder?.treatment_date) return '-'
    return moment(inProgressOrder.treatment_date).format('DD/MM/YYYY')
  }, [inProgressOrder?.treatment_date])

  return { userPhone, clinicAddress, clinicPhone, formattedTreatmentDate }
}
